const shared = require('./MLA9-Shared.js');
const stringHelper = require('../stringHelper.js');

module.exports = {
    getReference,
    getCitation
}

function getReference(refData) {
    let primaryInfo = getPrimaryInformation(refData);
    let firstSupplemental = getFirstSupplemental(refData);
    let containerOne = getContainerOne(refData);
    let containerTwo = getContainerTwo(refData);
    let secondSupplemental = getSecondSupplemental(refData);

    let referenceValue = primaryInfo;

    if (firstSupplemental.length > 0) {
        referenceValue = referenceValue + ' ' + firstSupplemental;
    }

    if (containerOne.length > 0) {
        referenceValue = referenceValue + ' ' + containerOne;
    }

    if (containerTwo.length > 0) {
        referenceValue = referenceValue + ' ' + containerTwo;
    }

    if (secondSupplemental.length > 0) {
        referenceValue = referenceValue + ' ' + secondSupplemental;
    }

    let primaryContributor = shared.getPrimaryContributorString(refData);
    let citationTitle = getCitationTitle(refData);
    let citationDate = getCitationDate(refData);

    let reference = {
        authorPart: primaryContributor,
        authorPartNoLabel : shared.getPrimaryContributorString(refData, true),
        authorPartSort: shared.getPrimaryContributorSort(refData),
        citationTitle : citationTitle,
        citationDate : citationDate,
        value: referenceValue.trim(),
        isPrintedOnReferencePage: true
    }

    return reference;
}

function getCitationTitle(refData){

    let citationTitle = '';
    
    citationTitle = shared.getStringValue(refData.title);

    if (citationTitle.length == 0) {
        citationTitle = shared.getStringValue(refData.content);
    }

    citationTitle = citationTitle.replaceAmpersand();

    return citationTitle;
}

function getCitationDate(refData){

    let citationDate = '';

    citationDate = shared.getStringValue(refData.publicationDate);

    return citationDate;
}

function getCitation(refData, citationData) {
    //define our citation logic for this type here
    let titleProperty = 'title';
    let isSecondaryTitle = true;

    let title = shared.getStringValue(refData.title);

    let formatTitle = false;
    if (title.length == 0) {
        titleProperty = 'content';
        formatTitle = true;
    }

    let citationTitle = getCitationTitle(refData);
    let citationDate = getCitationDate(refData);

    let primaryContributor = shared.getPrimaryContributorCitationString(refData, titleProperty, isSecondaryTitle,formatTitle);
    let citation = shared.getCitations(citationData, primaryContributor, citationTitle, citationDate);

    return citation;
}

function getPrimaryInformation(refData){
    let primaryPart = '';

    let primaryContributor = shared.getPrimaryContributorString(refData);

    primaryPart = primaryContributor;

	let type = shared.getStringValue(refData.type);

	if(type === 'post'){
		// content
		let content = shared.getStringValue(refData.content);
		if (content.length > 0) {

            if (primaryContributor.length > 0) {
                content = content.doubleQuote();
            }

			primaryPart = primaryPart.appendData(content, ' ');
		}
	} else if(type === 'page' || type === 'forum'){
		// title
		let title = shared.getStringValue(refData.title);
		if (title.length > 0) {
            title = title.replaceAmpersand();
			title = title.toTitleCase();
            title = title.doubleQuote();
            primaryPart = primaryPart.appendData(title, ' ');
		} else {
			// title is blank to use content
			let content = shared.getStringValue(refData.content);
			if (content.length > 0) {
				// content = content.doubleQuote();
				// primaryPart = primaryPart.appendData(content, ', ');
				primaryPart = primaryPart.appendData(content, ' ');
			}
		}
	}

	

    primaryPart = shared.fixClosure(primaryPart);
    
    return primaryPart;
}

function getFirstSupplemental(refData){
    let firstSupplemental = '';

    let type = shared.getStringValue(refData.type);
    let kind = shared.getStringValue(refData.kind);

    //TODO: add any first supplemental data needed

    firstSupplemental = firstSupplemental.upperFirstLetter();
    firstSupplemental = shared.fixClosure(firstSupplemental);

    return firstSupplemental;
}

function getContainerOne(refData){
    let container1 = '';   

    let type = shared.getStringValue(refData.type);
    let kind = shared.getStringValue(refData.kind);

    // platform
    let platform = shared.getStringValue(refData.platform);
	if (platform.length > 0) {
		platform = platform.italicize();
		container1 = container1.appendData(platform, ', ');
	}

	//publicationDate
	let publicationDate = shared.getStringValue(refData.publicationDate);
	publicationDate = shared.getFullDate(publicationDate);
	container1 = container1.appendData(publicationDate, ', ');

    //url
    let url = shared.getStringValue(refData.url);
    if (url.length > 0) {
        url = shared.formatURL(url);
        container1 = container1.appendData(url, ', ');
    }

    container1 = container1.upperFirstLetter();
    container1 = shared.fixClosure(container1);

    return container1;
}

function getContainerTwo(refData){
    let container2 = '';

    container2 = container2.upperFirstLetter();
    container2 = shared.fixClosure(container2);

    return container2;
}

function getSecondSupplemental(refData){
    let secondSupplemental = '';

    let type = shared.getStringValue(refData.type);

	//retrievalDate
	let retrievalDate = shared.getStringValue(refData.retrievalDate);
	retrievalDate = shared.getFullDate(retrievalDate);
	secondSupplemental = secondSupplemental.appendData(retrievalDate, ', ', 'Accessed');

	if(type === 'post' || type === 'forum'){
		// attachment
		let attachment = shared.getStringValue(refData.attachment);
		if(attachment.length > 0){
			attachment = attachment.toLowerCase();
			secondSupplemental = secondSupplemental.appendData(attachment, ', ');
		}
	} else if(type === 'page'){
		// description
		let description = shared.getStringValue(refData.description);
		if(description.length > 0){
			description = description.toLowerCase();
			secondSupplemental = secondSupplemental.appendData(description, ', ');
		}
	}
	

    secondSupplemental = secondSupplemental.upperFirstLetter();
    secondSupplemental = shared.fixClosure(secondSupplemental);

    return secondSupplemental;
}